/**
 * How the agent is paid on a new contract. The inviter picks it alongside the
 * commission level, and it travels with that level to the upline or carrier
 * (Paul, Oct 28): an advance gets set up as one (for example nine months),
 * as-earned is paid as it is earned.
 */
export const COMPENSATION_TYPES = ["ADVANCE", "AS_EARNED"];
export const COMPENSATION_TYPE_LABELS = {
    ADVANCE: "Advance",
    AS_EARNED: "As earned",
};
export function isCompensationType(value) {
    return typeof value === "string" && COMPENSATION_TYPES.includes(value);
}
/** Label for a stored value; null when nothing was chosen. */
export function compensationTypeLabel(value) {
    return isCompensationType(value) ? COMPENSATION_TYPE_LABELS[value] : null;
}
